module.exports = __webpack_public_path__ + "static/media/iconClose.53e4d8e2.svg";